module.exports = __webpack_public_path__ + "img/logo.e98e8cf6.png";